module.exports = __webpack_public_path__ + "img/blue-pencil.62a50a23.svg";